"use client";

var _excluded = ["transition", "beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
  _excluded2 = ["show", "appear", "unmount"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import f, { Fragment as O, createContext as ne, useContext as q, useEffect as he, useMemo as ie, useRef as E, useState as V } from "react";
import { useDisposables as ge } from '../../hooks/use-disposables.js';
import { useEvent as S } from '../../hooks/use-event.js';
import { useIsMounted as ve } from '../../hooks/use-is-mounted.js';
import { useIsoMorphicEffect as H } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as be } from '../../hooks/use-latest-value.js';
import { useServerHandoffComplete as re } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as oe } from '../../hooks/use-sync-refs.js';
import { transitionDataAttributes as Ee, useTransition as Se } from '../../hooks/use-transition.js';
import { OpenClosedProvider as ye, State as N, useOpenClosed as se } from '../../internal/open-closed.js';
import { classNames as Re } from '../../utils/class-names.js';
import { match as le } from '../../utils/match.js';
import { RenderFeatures as Pe, RenderStrategy as x, compact as xe, forwardRefWithAs as J, render as ae } from '../../utils/render.js';
function ue(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : de) !== O || f.Children.count(e.children) === 1;
}
var w = /*#__PURE__*/ne(null);
w.displayName = "TransitionContext";
var Ne = function (n) {
  return n.Visible = "visible", n.Hidden = "hidden", n;
}(Ne || {});
function _e() {
  var e = q(w);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function De() {
  var e = q(M);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
var M = /*#__PURE__*/ne(null);
M.displayName = "NestingContext";
function U(e) {
  return "children" in e ? U(e.children) : e.current.filter(function (_ref) {
    var t = _ref.el;
    return t.current !== null;
  }).filter(function (_ref2) {
    var t = _ref2.state;
    return t === "visible";
  }).length > 0;
}
function Te(e, t) {
  var n = be(e),
    l = E([]),
    y = ve(),
    R = ge(),
    T = S(function (o) {
      var _le;
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x.Hidden;
      var a = l.current.findIndex(function (_ref3) {
        var s = _ref3.el;
        return s === o;
      });
      a !== -1 && (le(i, (_le = {}, _defineProperty(_le, x.Unmount, function () {
        l.current.splice(a, 1);
      }), _defineProperty(_le, x.Hidden, function () {
        l.current[a].state = "hidden";
      }), _le)), R.microTask(function () {
        var s;
        !U(l) && y.current && ((s = n.current) == null || s.call(n));
      }));
    }),
    P = S(function (o) {
      var i = l.current.find(function (_ref4) {
        var a = _ref4.el;
        return a === o;
      });
      return i ? i.state !== "visible" && (i.state = "visible") : l.current.push({
        el: o,
        state: "visible"
      }), function () {
        return T(o, x.Unmount);
      };
    }),
    p = E([]),
    m = E(Promise.resolve()),
    C = E({
      enter: [],
      leave: []
    }),
    h = S(function (o, i, a) {
      p.current.splice(0), t && (t.chains.current[i] = t.chains.current[i].filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          s = _ref6[0];
        return s !== o;
      })), t == null || t.chains.current[i].push([o, new Promise(function (s) {
        p.current.push(s);
      })]), t == null || t.chains.current[i].push([o, new Promise(function (s) {
        Promise.all(C.current[i].map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            r = _ref8[0],
            d = _ref8[1];
          return d;
        })).then(function () {
          return s();
        });
      })]), i === "enter" ? m.current = m.current.then(function () {
        return t == null ? void 0 : t.wait.current;
      }).then(function () {
        return a(i);
      }) : a(i);
    }),
    g = S(function (o, i, a) {
      Promise.all(C.current[i].splice(0).map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          s = _ref10[0],
          r = _ref10[1];
        return r;
      })).then(function () {
        var s;
        (s = p.current.shift()) == null || s();
      }).then(function () {
        return a(i);
      });
    });
  return ie(function () {
    return {
      children: l,
      register: P,
      unregister: T,
      onStart: h,
      onStop: g,
      wait: m,
      chains: C
    };
  }, [P, T, l, h, g, C, m]);
}
var de = O,
  fe = Pe.RenderStrategy;
function He(e, t) {
  var ee, te;
  var _e$transition = e.transition,
    n = _e$transition === void 0 ? !0 : _e$transition,
    l = e.beforeEnter,
    y = e.afterEnter,
    R = e.beforeLeave,
    T = e.afterLeave,
    P = e.enter,
    p = e.enterFrom,
    m = e.enterTo,
    C = e.entered,
    h = e.leave,
    g = e.leaveFrom,
    o = e.leaveTo,
    i = _objectWithoutProperties(e, _excluded),
    _V = V(null),
    _V2 = _slicedToArray(_V, 2),
    a = _V2[0],
    s = _V2[1],
    r = E(null),
    d = ue(e),
    j = oe.apply(void 0, _toConsumableArray(d ? [r, t, s] : t === null ? [] : [t])),
    v = (ee = i.unmount) == null || ee ? x.Unmount : x.Hidden,
    _e2 = _e(),
    c = _e2.show,
    z = _e2.appear,
    K = _e2.initial,
    _V3 = V(c ? "visible" : "hidden"),
    _V4 = _slicedToArray(_V3, 2),
    b = _V4[0],
    G = _V4[1],
    Q = De(),
    A = Q.register,
    I = Q.unregister;
  H(function () {
    return A(r);
  }, [A, r]), H(function () {
    if (v === x.Hidden && r.current) {
      var _le2;
      if (c && b !== "visible") {
        G("visible");
        return;
      }
      return le(b, (_le2 = {}, _defineProperty(_le2, "hidden", function hidden() {
        return I(r);
      }), _defineProperty(_le2, "visible", function visible() {
        return A(r);
      }), _le2));
    }
  }, [b, r, A, I, c, v]);
  var B = re();
  H(function () {
    if (d && B && b === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [r, b, B, d]);
  var ce = K && !z,
    Y = z && c && K,
    W = E(!1),
    F = Te(function () {
      W.current || (G("hidden"), I(r));
    }, Q),
    Z = S(function (k) {
      W.current = !0;
      var L = k ? "enter" : "leave";
      F.onStart(r, L, function (D) {
        D === "enter" ? l == null || l() : D === "leave" && (R == null || R());
      });
    }),
    $ = S(function (k) {
      var L = k ? "enter" : "leave";
      W.current = !1, F.onStop(r, L, function (D) {
        D === "enter" ? y == null || y() : D === "leave" && (T == null || T());
      }), L === "leave" && !U(F) && (G("hidden"), I(r));
    });
  he(function () {
    d && n || (Z(c), $(c));
  }, [c, d, n]);
  var pe = function () {
      return !(!n || !d || !B || ce);
    }(),
    _Se = Se(pe, a, c, {
      start: Z,
      end: $
    }),
    _Se2 = _slicedToArray(_Se, 2),
    u = _Se2[1],
    Ce = xe(_objectSpread({
      ref: j,
      className: ((te = Re(i.className, Y && P, Y && p, u.enter && P, u.enter && u.closed && p, u.enter && !u.closed && m, u.leave && h, u.leave && !u.closed && g, u.leave && u.closed && o, !u.transition && c && C)) == null ? void 0 : te.trim()) || void 0
    }, Ee(u))),
    _ = 0;
  return b === "visible" && (_ |= N.Open), b === "hidden" && (_ |= N.Closed), u.enter && (_ |= N.Opening), u.leave && (_ |= N.Closing), /*#__PURE__*/f.createElement(M.Provider, {
    value: F
  }, /*#__PURE__*/f.createElement(ye, {
    value: _
  }, ae({
    ourProps: Ce,
    theirProps: i,
    defaultTag: de,
    features: fe,
    visible: b === "visible",
    name: "Transition.Child"
  })));
}
function Ae(e, t) {
  var n = e.show,
    _e$appear = e.appear,
    l = _e$appear === void 0 ? !1 : _e$appear,
    _e$unmount = e.unmount,
    y = _e$unmount === void 0 ? !0 : _e$unmount,
    R = _objectWithoutProperties(e, _excluded2),
    T = E(null),
    P = ue(e),
    p = oe.apply(void 0, _toConsumableArray(P ? [T, t] : t === null ? [] : [t]));
  re();
  var m = se();
  if (n === void 0 && m !== null && (n = (m & N.Open) === N.Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  var _V5 = V(n ? "visible" : "hidden"),
    _V6 = _slicedToArray(_V5, 2),
    C = _V6[0],
    h = _V6[1],
    g = Te(function () {
      n || h("hidden");
    }),
    _V7 = V(!0),
    _V8 = _slicedToArray(_V7, 2),
    o = _V8[0],
    i = _V8[1],
    a = E([n]);
  H(function () {
    o !== !1 && a.current[a.current.length - 1] !== n && (a.current.push(n), i(!1));
  }, [a, n]);
  var s = ie(function () {
    return {
      show: n,
      appear: l,
      initial: o
    };
  }, [n, l, o]);
  H(function () {
    n ? h("visible") : !U(g) && T.current !== null && h("hidden");
  }, [n, g]);
  var r = {
      unmount: y
    },
    d = S(function () {
      var v;
      o && i(!1), (v = e.beforeEnter) == null || v.call(e);
    }),
    j = S(function () {
      var v;
      o && i(!1), (v = e.beforeLeave) == null || v.call(e);
    });
  return /*#__PURE__*/f.createElement(M.Provider, {
    value: g
  }, /*#__PURE__*/f.createElement(w.Provider, {
    value: s
  }, ae({
    ourProps: _objectSpread(_objectSpread({}, r), {}, {
      as: O,
      children: /*#__PURE__*/f.createElement(me, _objectSpread(_objectSpread(_objectSpread({
        ref: p
      }, r), R), {}, {
        beforeEnter: d,
        beforeLeave: j
      }))
    }),
    theirProps: {},
    defaultTag: O,
    features: fe,
    visible: C === "visible",
    name: "Transition"
  })));
}
function Ie(e, t) {
  var n = q(w) !== null,
    l = se() !== null;
  return /*#__PURE__*/f.createElement(f.Fragment, null, !n && l ? /*#__PURE__*/f.createElement(X, _objectSpread({
    ref: t
  }, e)) : /*#__PURE__*/f.createElement(me, _objectSpread({
    ref: t
  }, e)));
}
var X = J(Ae),
  me = J(He),
  Fe = J(Ie),
  Xe = Object.assign(X, {
    Child: Fe,
    Root: X
  });
export { Xe as Transition, Fe as TransitionChild };